import { useIntl } from 'react-intl';

const LegalNotice = () => {
    const intl = useIntl();

    return (
        <div className="product-page__legal-notice-wrapper">
            <h6>{intl.formatMessage({ id: 'product.legalNoticeTitle', defaultMessage: 'Rechtliche Hinweise:' })}</h6>
            {/* <div style={{ display: 'flex' }}> */}
            <div>
                <p>
                    {intl.formatMessage({
                        id: 'product.legalNoticeDesc',
                        defaultMessage: 'Angebots- und Preisänderungen vorbehalten. Basis:',
                    })}
                </p>
                <a
                    href={`https://www.apgsga.ch/${intl.locale}/agb/`}
                    // style={{ marginLeft: '4px' }}
                    target={'_blank'}
                    rel="noreferrer"
                >
                    {intl.formatMessage({
                        id: 'product.legalNoticeLinkText',
                        defaultMessage: 'Allgemeine Geschäftsbedingungen APG|SGA',
                    })}
                </a>
            </div>
        </div>
    );
};

export default LegalNotice;
